module.exports = __webpack_public_path__ + "img/hr-straight-rail-horizontal-ties.6fd30ccc.png";